import { render } from "./TenantForm.vue?vue&type=template&id=3fa2a145&scoped=true&ts=true"
import script from "./TenantForm.vue?vue&type=script&lang=ts"
export * from "./TenantForm.vue?vue&type=script&lang=ts"

import "./TenantForm.vue?vue&type=style&index=0&id=3fa2a145&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fa2a145"]])

export default __exports__